// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1fCUy","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1JIQt"};